module.exports = __webpack_public_path__ + "img/seg.ab12b956.png";